module.exports = __webpack_public_path__ + "static/media/IMG_3456-min.1d2ef9be.JPG";